<app-button color="primary" icon="settings" routerLink="/settings"></app-button>
